import DesignTokens from '@tableau/design-tokens';
import { SpotBellBaseIcon } from '@tableau/icons/SpotBellBaseIcon';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { Messages } from '../../codegen/Localize';
import { NotificationCenterStyles } from '../styles/notificationCenterStyles';

export function NotificationLoadFail() {
  return (
    <div className='loadingNotificationFailed' style={NotificationCenterStyles.notificationEmptyList}>
      <div className='bellImg'> <SpotBellBaseIcon size={80} alt='' color={applyColor(DesignTokens.color.font.default.secondary, '#666')} /></div>
      <div className='errorMessage' style={NotificationCenterStyles.notificationEmptyTitle}> {Messages.userNotificationLoadError()} </div>
      <div className='tryAgainLater' style={NotificationCenterStyles.notificationSecondTitle}> {Messages.userNotificationTryAgainLater()} </div>
    </div>
  );
}
